import { styled } from "styled-components";

export const VoteContainer = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  border-radius: 12px;
  border: ${({ theme }) => `1px solid ${theme.colors.default[50]}`};
  height: 110px;
`;

export const VoteButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const VoteButton = styled.button<{ $active?: boolean }>`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: ${({ theme, $active }) =>
    $active
      ? `1px solid ${theme.colors.success.default}`
      : `1px solid ${theme.colors.default[100]}`};
  color: ${({ theme, $active }) =>
    $active ? `${theme.colors.success.default}` : undefined};
  background: var(--White, ${({ theme }) => theme.colors.base});
  box-shadow: 0px 1px 2px 0px rgba(13, 17, 43, 0.05);
  transition: all 0.2s ease-in-out;
`;

export const ContactText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;
